<template>
    <div id="spinner-container">
        <div class="spinner"></div>
    </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
#spinner-container {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    @keyframes spinner {
        0% {
            transform: translate3d(-50%, -50%, 0) rotate(0deg);
        }
        100% {
            transform: translate3d(-50%, -50%, 0) rotate(360deg);
        }
    }

    .spinner {
        // The height here is just for demo purposes
        opacity: 1;
        position: relative;
        transition: opacity linear 0.1s;

        &::before {
            animation: 2s linear infinite spinner;
            border: solid 3px $color-gray;
            border-bottom-color: $color-primary;
            border-radius: 50%;
            content: '';
            height: 80px;
            left: 50%;
            position: absolute;
            top: 50%;
            transform: translate3d(-50%, -50%, 0);
            transform-origin: center;
            width: 80px;
            will-change: transform;
        }
    }
}
</style>
